import { DEFAULT_DMS_ROUTES } from '@localstack/constants';
import { ReactElement } from 'react';
import { CreateReplicationInstanceMessage } from '@localstack/types';
import { Breadcrumbs, DMSReplicationInstanceForm, ProgressButton } from '@localstack/ui';
import { useAwsEffect, useRoutes } from '@localstack/services';
import { Box, Card, CardActions, CardContent, Typography } from '@mui/material';

import { DMSProps } from './types';

export const DMSReplicationInstanceCreate = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_DMS_ROUTES,
}: DMSProps): ReactElement => {
  const { goto } = useRoutes();
  const { createReplicationInstance, isLoading } = useAwsEffect('DMS', ['createReplicationInstance'], {
    clientOverrides,
    revalidate: ['describeReplicationInstances'],
  });

  const handleCreate = async (data: CreateReplicationInstanceMessage) => {
    if (await createReplicationInstance(data)) {
      goto(routes.RESOURCES_DMS_REPLICATION_INSTANCES);
    }
  };

  return (
    <Layout
      title={
        <Box>
          <Typography variant="h4">Replication Instance Details</Typography>
          <Breadcrumbs
            mappings={[
              ['DMS', () => goto(routes.RESOURCES_DMS_REPLICATION_INSTANCES)],
              ['Replication Instances', () => goto(routes.RESOURCES_DMS_REPLICATION_INSTANCES)],
              ['Create', null],
            ]}
          />
        </Box>
      }
      actions={
        <ProgressButton
          color="primary"
          variant="outlined"
          type="submit"
          form="DMSReplicationInstanceCreate"
          loading={isLoading}
        >
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <DMSReplicationInstanceForm
            formId="DMSReplicationInstanceCreate"
            onSubmit={handleCreate}
            loading={isLoading}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            color="primary"
            variant="outlined"
            type="submit"
            form="DMSReplicationInstanceCreate"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
